/**
 * @fileoverview DELETE handler for the "/:app_group_id/campaign_brief/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { campaignBriefCacheKeys } from "./constants";
import type { DeleteCampaignBriefProps, DeleteCampaignBriefResult } from "./types";

export const deleteCampaignBrief = reactQueryMutationAdapter(
  campaignBriefCacheKeys,
  (props: DeleteCampaignBriefProps): Promise<DeleteCampaignBriefResult> => {
    return fetch(`/${props.appGroupId}/campaign_brief/${props.campaignId}`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
